import * as React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

const steps = [
    "Placed",
    "Cancel",
    "Accepted",
];

export default function CancleOrderTracker({ activeStep }) {
    return (
        <Stepper
            activeStep={activeStep - 1}
            // alternativeLabel={isMobile}
            sx={{
                "& .MuiStepConnector-line": {
                    borderColor: "#e5e7eb",
                },
                "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
                    borderColor: "#374151",
                },
                "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
                    borderColor: "#374151",
                },
            }}
        >
            {steps.map((label, index) => {
                const stepNumber = index + 1;
                const isCompleted = stepNumber < activeStep;
                const isActive = stepNumber === activeStep;

                return (
                    <Step key={label}>
                        <StepLabel
                            sx={{
                                "& .MuiStepIcon-root": {
                                    color: isActive || isCompleted ? "#374151" : "#d1d5db",
                                    fontSize: "1.5rem",
                                    "&.Mui-active": {
                                        color: "#374151",
                                    },
                                    "&.Mui-completed": {
                                        color: "#374151",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    color: isActive || isCompleted ? "#374151" : "#9ca3af",
                                    fontWeight: isActive ? "600" : isCompleted ? "500" : "400",
                                    fontSize: "0.875rem",
                                    mt: 1
                                },
                                "& .MuiStepLabel-labelContainer": {
                                    "& .MuiStepLabel-optional": {
                                        display: "none"
                                    }
                                }
                            }}
                        >
                            {label}
                        </StepLabel>
                    </Step>
                );
            })}
        </Stepper>
    );
}
